import { render, staticRenderFns } from "./workPrograms.vue?vue&type=template&id=b4810d80&scoped=true&"
import script from "./workPrograms.vue?vue&type=script&lang=js&"
export * from "./workPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4810d80",
  null
  
)

export default component.exports